import React, { Component } from 'react';
/*import PropTypes from 'prop-types'*/
import Aux from '../../../_hoc/_Aux';
import styles from './Radio.scss';

import newId from '../../../_util/newId';

class Radio extends Component {
  componentWillMount() {
      this.id = newId();
  }
  render() {
    return (
    	<Aux>
    		<input  className={styles.defaultInput}
                onChange={(event) => this.props.changed(event, this.props.identifier)}
                value={this.props.value}
                type='radio'
                checked={this.props.checked ? true : false}
                data-hasvalue={this.props.value !== null && this.props.value !== "" ? true : false}
                disabled={this.props.disabled ? true : false}
                id={this.id}
                name={this.props.identifier}/>
        <label htmlFor={this.id}><span>&nbsp;</span></label>
        <label htmlFor={this.id}>{this.props.label}</label>
      </Aux>
    )
  }
}

export default Radio



// WEBPACK FOOTER //
// ./src/components/atoms/Radio/index.js